import {
  CreateGoalCurrentValueDto,
  CreateGoalDto,
  FivGoalFilterDto,
  GoalFilter,
  GoalsFilterDto,
  IFivGoalResult,
  IGoal,
  IGoalCurrentValue,
  IGoalResult,
  TeamGoalsFilterDto,
  UpdateGoalDto,
  UpdateGoalOrderDto,
} from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';
import { UpdateGoalValueDto } from 'admiral-core/dist/dtos/goal/update-goal-value.dto';

export class GoalApi {
  static getFivGoalResult(dto?: FivGoalFilterDto): Promise<AxiosResponse<IFivGoalResult>> {
    return AdmiralApi.apiCall<IFivGoalResult>({
      method: 'POST',
      url: `${BASE_URL}/fiv/goal/result`,
      data: dto,
    });
  }

  static getGoalResult(id: string, businessyear: number): Promise<AxiosResponse<IGoalResult>> {
    return AdmiralApi.apiCall<IGoalResult>({
      method: 'POST',
      url: `${BASE_URL}/goal/${id}/result?businessyear=${businessyear}`,
    });
  }
  static getGoal(filter?: GoalFilter): Promise<AxiosResponse> {
    return AdmiralApi.apiCall<IGoal>({
      method: 'POST',
      url: `${BASE_URL}/goal/list`,
      data: filter,
    });
  }

  static getGoals(dto: GoalsFilterDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall<IGoal>({
      method: 'POST',
      url: `${BASE_URL}/goal`,
      data: dto,
    });
  }

  static update(updateGoalDto: UpdateGoalDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall<IGoal>({
      method: 'PUT',
      url: `${BASE_URL}/goal/update`,
      data: updateGoalDto,
    });
  }

  static delete(id: string): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      url: `${BASE_URL}/goal/${id}`,
      method: 'DELETE',
    });
  }

  static create(createGoalDto: CreateGoalDto): Promise<AxiosResponse<IGoal>> {
    return AdmiralApi.apiCall<IGoal>({
      method: 'PUT',
      url: `${BASE_URL}/goal`,
      data: createGoalDto,
    });
  }

  static createGoalCurrentValue(
    dto: CreateGoalCurrentValueDto,
  ): Promise<AxiosResponse<IGoalCurrentValue>> {
    return AdmiralApi.apiCall<IGoalCurrentValue>({
      method: 'PUT',
      url: `${BASE_URL}/goal/goal-current-value`,
      data: dto,
    });
  }

  static updateGoalValue(id: string, dto: UpdateGoalValueDto): Promise<AxiosResponse<IGoal>> {
    return AdmiralApi.apiCall<IGoal>({
      method: 'PATCH',
      url: `${BASE_URL}/goal/${id}/goal-value`,
      data: dto,
    });
  }

  static updateGoal(id: string, dto: UpdateGoalDto): Promise<AxiosResponse<IGoal>> {
    return AdmiralApi.apiCall<IGoal>({
      method: 'PATCH',
      url: `${BASE_URL}/goal/${id}`,
      data: dto,
    });
  }

  static updateGoalOrder(dto: UpdateGoalOrderDto): Promise<AxiosResponse<IGoal[]>> {
    console.log(dto);
    return AdmiralApi.apiCall<IGoal[]>({
      method: 'POST',
      url: `${BASE_URL}/goal/order`,
      data: dto,
    });
  }

  static duplicateGoal(id: string): Promise<AxiosResponse<IGoal>> {
    return AdmiralApi.apiCall<IGoal>({
      method: 'POST',
      url: `${BASE_URL}/goal/${id}/duplicate`,
    });
  }
}
